import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

type ExtendedLabelProps = {
  text: React.ReactNode;
};

const ExtendedLabel: React.FC<ExtendedLabelProps> = ({ text }) => {
  const [visible, setVisible] = useState(false);

  const dialogfooterContent = (
    <div className="flex justify-center border-t p-5 w-full">
      <Button label="Close" icon="pi pi-times" onClick={() => setVisible(false)} className="hint-button mr-3 px-2 py-3" />
    </div>
  );

  const dialogheaderContent = (
    <div className="flex items-center gap-2">
      <span className="hint">Hint</span>
    </div>
  );
  return (
    <>
      <Button
        label="Hint"
        className="hint-button "
        icon="pi pi-info-circle"
        iconPos="left"
        onClick={(e) => {
          e.preventDefault();
          setVisible(true);
        }}
      />
      <Dialog
        header={dialogheaderContent}
        footer={dialogfooterContent}
        visible={visible}
        className="extended-label-container"
        style={{ width: "50vw", height: "auto" }}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}>
        <div>{text}</div>
      </Dialog>
    </>
  );
};

export default ExtendedLabel;
